import { FieldError, FieldErrors, FieldErrorsImpl, Merge } from "react-hook-form";

export function getNestedError(
  errors: FieldErrors,
  path: string,
): FieldError | Merge<FieldError, FieldErrorsImpl> | undefined {
  // @ts-ignore: Ignoring the compiler and risking bugs because: cannot infer the nested structure of errors for dynamic dot-notation keys
  return path.split(".").reduce((acc, part) => acc?.[part], errors);
}
